import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ categories, setSelectedCategory }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const navStyles = {
    navbar: {
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backgroundColor: 'white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    brand: {
      fontWeight: 'bold',
      color: '#2c3e50',
      textDecoration: 'none',
      fontSize: '1.5rem'
    },
    categoryItem: {
      padding: '8px 16px',
      margin: '0 5px',
      cursor: 'pointer',
      borderRadius: '4px',
      transition: 'background-color 0.3s',
      color: '#34495e'
    },
    mobileMenu: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: 'white',
      padding: '10px 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      display: isOpen ? 'block' : 'none'
    }
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setIsOpen(false);
    navigate('/');
  };

  return (
    <nav style={navStyles.navbar} className="navbar navbar-expand-lg">
      <div className="container">
      <a 
  style={{
    ...navStyles.brand,
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }} 
  className="navbar-brand" 
  href="/"
  onClick={(e) => {
    e.preventDefault();
    navigate('/');
  }}
>
  <img 
    src="https://naveenak.netlify.app/img/black.jpeg" 
    alt="Movie Buzz Logo" 
    style={{
      height: '40px',
      width: 'auto',
      objectFit: 'contain'
    }}
  />
</a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div 
          className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}
          style={{ flexGrow: 0 }}
        >
          <div className="navbar-nav d-flex align-items-center">
            {categories.map((category) => (
              <div
                key={category.name}
                style={navStyles.categoryItem}
                className="nav-item"
                onClick={() => handleCategoryClick(category)}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f2f5'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                {category.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
